import { useMemo, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export interface MyOrgUnit {
  orgUnitId: string;
  orgUnitName: string;
}

export function useActiveOrgUnit(myOrgUnits: MyOrgUnit[]) {
  const [params, setParams] = useSearchParams();

  const activeOrgUnitId = useMemo(() => {
    const qp = params.get('orgUnitId');
    if (qp && myOrgUnits.some((o) => o.orgUnitId === qp)) return qp;
    return myOrgUnits[0]?.orgUnitId ?? null;
  }, [params, myOrgUnits]);

  const setActiveOrgUnit = useCallback(
    (id: string) => {
      const next = new URLSearchParams(params);
      next.set('orgUnitId', id);
      setParams(next, { replace: true });
    },
    [params, setParams],
  );

  return { activeOrgUnitId, setActiveOrgUnit };
}
